import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { Presentation } from "../../../../core/gameflow/controller/Presentation";
import { MathHelper } from "../../../../core/utils/MathHelper";
import { SoundManager } from "../../../config/sound/SoundManager";
import { ReelState } from "../../../../core/reel/ReelEngineView";
import { SoundConfig } from "../../../config/sound/SoundConfig";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SanQuentin2 } from "../../../SanQuentin2";
import { SanEngineController } from "../../../engine/SanEngineController";
import { RevealerManager } from "../../../modules/revealer/RevealerManager";
import { Revealer } from "../../../modules/revealer/Revealer";
import { IdlePresentation } from "../../features/idle/IdlePresentation";

export class StartPresentation extends Presentation {

    protected addExtraForStart?(reel:SanEngineController):void;

    preStart(): void {
        SanEngineManager.onBeforeSpinStart(true);
        IdlePresentation.DisableNormalIdle();
        SanQuentin2.xWaysCounter.setValue(undefined,1024,0.25);
        SanEngineManager.RSAll((rc, sym) => { sym.stopWin(0.2) })
    }

    createPresentation() {
        if(!this.barStuff()){

            SanQuentin2.reelEngineManager.applyMask(true);
            SanEngineManager.revealer.applyIndiviMask(true);
            
            this.startReels();
            this.setPlayable(false);
        }
    }

    barStuff():boolean{

        RevealerManager.getAllBars().forEach(r => r.setInteractive(false));

        SanEngineManager.RAll(rc => {
            const revTop:Revealer = RevealerManager.getTopBar(rc.reelID);
            const revBott:Revealer = RevealerManager.getBotBar(rc.reelID);

            if(revTop.hasStopped && (revTop.isExpanded || revBott.isExpanded)){
                if(revTop.isExpanded && revBott.isExpanded){
                    revTop.xWaysReset();
                    revBott.xWaysReset();
                }
                else{
                    SanEngineManager.getReel(rc.reelID).applySymbolsFromXWays(revTop);
                    SanEngineManager.getReel(rc.reelID).applySymbolsFromXWays(revBott);
                }
            }
        });

        const bars:Revealer[] = RevealerManager.getAllBars();

        let expandDelay:number = 0;

        bars.forEach((v => {
            if(v.isActive) this.timeline.add(v.closeBar(),expandDelay);
        }))

        return !!this.timeline.duration();
    }

    startReels():void{

        SanEngineManager.RAll((rc: SanEngineController) => rc.createStart({ start:() => this.addExtraForStart ? this.addExtraForStart(rc) : undefined }) );

        let delay: number = 0;
        const startReel:number = SanEngineManager.findReelWithState(ReelState.START, true);
        SanEngineManager.RAll(reel => {
            if(reel.reelID == startReel) this.timeline.add( () => {SoundManager.playSoundEffect(SoundConfig.REELS_SPINNING, Number.MAX_SAFE_INTEGER)}, delay);
            this.timeline.add(() => {
                reel.startReel();
                reel.changeAlpha(0.4, 1);
                RevealerManager.getTopBar(reel.reelID).shuffle(true);
                RevealerManager.getBotBar(reel.reelID).shuffle(true);
            }, delay);
            if(reel.isActive) delay += reel.startDelay;
        })
        // if only one reel starts, there is no time delay. Need to add some duration to trigger the elements in an gsap timeline.
        this.timeline.duration() == 0 ? this.timeline.to(this, { duration: MathHelper.frameToSeconds(1)}) : null;
    }
   
    skip(): void {
        SanEngineManager.isQuickStop = true;
    }

    done(): void {
        // SanQuentin2.reelEngineManager.bounceScreen();
        Logger.logDev("Start Done");
    }
}